import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_BottomToolbar,
    MRT_GlobalFilterTextField, MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import FilterUtil from "../../../../utils/common/FilterUtil";
import CellCheckboxWithUnable from "../../сheckbox/CellCheckboxWithUnable";
import ModalAddDetail from "./ModalAddDetail";
import {Link, useLocation, useNavigate} from "react-router-dom";
import ModalAlert from "./ModalAlert";
import {constantsErrorMessages} from "../../../../Constants";
import ButtonCreate, {buttonCreateAutoSizeSx} from "../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import {Paper, Tooltip} from "@mui/material";
import ButtonSelectAction from "../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../modal/ModalSelectAction";
import SamplesControllerService from "../../../../API/samples/Customers/SamplesController";
import ModalImport from "./processing/ModalImport";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalSeeDetail from "./SeeDetail";
import ModalAddBySamples from "./ModalAddBySamples";
import SamplesControllerServiceAdmin from "../../../../API/samples/Admin/SamplesControllerAdmin";
import ModalAddPackaging from "./ModalAddPackaging";
import DetailControllerService from "../../../../API/details/customer/DetailControllerService";
import PackagingControllerService from "../../../../API/details/customer/PackagingControllerService";

const CustomerDetailsTable = ({
                                  data,
                                  materialTreeData,
                                  setChange,
                                  isError,
                                  unableTurn,
                                  isColumnMaterial,
                                  isColumnOrder,
                                  enableGrouping,
                                  columnGrouping,
                                  setData,
                                  orderId,
                                  requestsCuttingId,
                                  requestsCuttingNumber,
                                  customerOrderNumber,
                                  tableOptions,
                                  tableOptionsHandle,
                                  samples = false,
                                  system,
                                  admin,
                                  modal = false,
                                  selectedSamples,
                                  setSelectedSamples,
                                  year,
                                  handleActiveItemsChange
                              }) => {
        const navigate = useNavigate();
        const location = useLocation();
        const materialId = new URLSearchParams(location.search).get('materialId');
        const redirectProcessing = (el) => {
            samples ?
                navigate(`/customer/samples/details/${el.id}`) :
                requestsCuttingId ?
                    navigate(`/customer/orders/${orderId}/${encodeURIComponent(customerOrderNumber)}/${year}/requests-cutting/${requestsCuttingId}/${encodeURIComponent(requestsCuttingNumber)}/details/${el.id}`) :
                    navigate(`/customer/orders/${orderId}/${encodeURIComponent(customerOrderNumber)}/${year}/requests-cutting/details/${el.id}`);
        };
        const [open, setOpen] = useState(false)
        const [modalPackaging, setModalPackaging] = useState(false)
        const [modalImportOpen, setModalImportOpen] = useState(false)
        const [seeDetailData, setSeeDetailData] = useState({position: null, data: null})
        const popoverOpen = Boolean(seeDetailData.position);

        const [modalSamplesOpen, setModalSamplesOpen] = useState(false)

        const [createOrUpdateModalOpen, setCreateOrUpdateModalOpen] = useState(false);
        const [alertData, setAlertData] = useState({});

        const rowInitValue = {
            position: "",
            name: "",
            length: "",
            height: "18",
            width: "",
            quantity: "",
        }

        const [rowSelection, setRowSelection] = useState({});
        const [currentEditRowData, setCurrentEditRowData] = useState(rowInitValue);
        const [currentEditRowId, setCurrentEditRowId] = useState(null);
        const [initValueGroup, setInitValueGroup] = useState({})
        const [isNew, setIsNew] = useState(null);
        const [loading, setLoading] = useState(false)

        const uniqueNames = data.map(el => el.position)

        const handleCloseAlert = () => {
            setAlertData((alert) => {
                return {...alert, open: false}
            })
        }
        const handleModalAlert = (message, type = "error") => {
            setAlertData({
                type: type,
                open: true,
                message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
            })
        }
        const handleAddPackaging = (row) => {
            setModalPackaging(true)
            setCurrentEditRowData(row)
        }
        const handleCloseAddPackaging = () => {
            setCurrentEditRowId(null);
            setModalPackaging(false);
        };

        const handleUpdateDetail = (row) => {
            if (samples) {
                const {detailDto, group} = row;
                setCurrentEditRowData((prev) => {
                    return Object.keys(prev).reduce((acc, it) => ({...acc, [it]: detailDto[it]}), {})
                });
                setInitValueGroup({id: group.id, name: group.name})
                setCurrentEditRowId(row.id);
            } else {
                setCurrentEditRowData((prev) => {
                    return Object.keys(prev).reduce((acc, it) => ({...acc, [it]: row[it]}), {})
                });
                setCurrentEditRowId(row.id);
            }

            setIsNew(false);
            setCreateOrUpdateModalOpen(true);
        }

        const handleDeleteDetail = (row) => {
            if (samples) {
                const api = admin ? SamplesControllerServiceAdmin : SamplesControllerService
                api.delete(row.id).then(function (response) {
                    setChange(change => !change)
                    handleModalAlert("Данные удалены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error)
                    })

            } else {
                DetailControllerService.delete(orderId, row)
                    .then(function () {
                        setData(prev => prev.filter(el => el.id !== row.id))
                        handleModalAlert("Данные удалены", 'success')
                    })
                    .catch(function (error) {
                        handleModalAlert(error)
                    })
            }
        };
        const removePackaging = (row) => {
            PackagingControllerService.removeByDetailId(orderId, row.id)
                .then(function (response) {
                    setData(prev => prev.map(el => el.id === row.id ? response.data : el))
                    handleModalAlert("Данные изменены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
        }
        const handleAddPackagingByDetailId = (value) => {
            setLoading(true)
            PackagingControllerService.addByDetailId(orderId, currentEditRowData.id, {
                "packagingId": value.id
            })
                .then(function (response) {
                    setData(prev => prev.map(el => el.id === currentEditRowData.id ? response.data : el))
                    handleCloseAddPackaging()
                    handleModalAlert("Данные изменены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error)
                }).finally(() => setLoading(false))
        }

        const handleAddDetail = () => {
            setIsNew(true);
            const detail = samples ? {...rowInitValue, quantity: "1"} : rowInitValue
            setCurrentEditRowData(detail);
            setCreateOrUpdateModalOpen(true);
        };

        const handleSubmitCreateDetail = (values) => {
            setLoading(true)
            if (samples) {
                const api = admin ? SamplesControllerServiceAdmin : SamplesControllerService
                api.save({
                    createDetailDto: values.dto,
                    groupId: values.groupId
                }).then(function (response) {
                    setChange(change => !change)
                    handleModalAlert("Данные добавлены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error)
                    })
                    .then(handleCloseCreateOrUpdate)
                    .finally(() => setLoading(false))

            } else {
                DetailControllerService.save(orderId, requestsCuttingId, values).then(function (response) {
                    setData(value => [...value, response.data])
                    handleModalAlert("Данные добавлены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error)
                    })
                    .then(handleCloseCreateOrUpdate)
                    .finally(() => setLoading(false))
            }
        }
        const handleSubmitUpdateDetail = (values) => {

            if (samples) {
                const api = admin ? SamplesControllerServiceAdmin : SamplesControllerService
                api.update(currentEditRowId, {
                    "updateDetailDto": values.dto,
                    "groupId": values.groupId
                }).then(function (response) {
                    setChange(change => !change)
                    handleModalAlert("Данные изменены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error)
                    })
                    .then(handleCloseCreateOrUpdate)

            } else {
                DetailControllerService.update(orderId, currentEditRowId, values).then(function (response) {
                    setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
                    handleModalAlert("Данные изменены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error)
                    })
                    .then(handleCloseCreateOrUpdate)
            }

        }

        const handleCloseCreateOrUpdate = () => {
            setIsNew(null);
            setCurrentEditRowId(null);
            setCreateOrUpdateModalOpen(false);
        };

        const handleOpenSeeDetail = (position, rowData) => {
            setSeeDetailData({position, data: rowData})
        }
        const handleSubmitSamples = (data, selectedType, handleClose) => {
            setLoading(true)
            DetailControllerService.saveBySample(orderId, requestsCuttingId, data).then(function (response) {
                setData(value => [...value, response.data])
                handleClose()
                handleModalAlert("Данные добавлены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error)

                }).finally(() => setLoading(false))

        }

        const columns = useMemo(() => {
            const baseColumns = [{
                id: 'position',
                header: 'Позиция',
                accessorKey: samples ? "detailDto.position" : "position",
                size: 300,
                grow: true,
                Cell: ({cell, row}) => {
                    const rowData = samples ? row.original.detailDto : row.original
                    const id = samples ? row.original.id : rowData.id
                    return <li key={cell.getValue()} style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingRight: "10px"
                    }}>
                        <Tooltip
                            arrow
                            placement="right"
                            disableHoverListener={rowData.requiresImprovement !== true}
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        width: '220px',
                                    },
                                },
                            }}
                            title="При импорте из файла приложение не смогло определить тип кромки">
                            {modal ? cell.getValue() :
                                <Link
                                    to={samples ?
                                        `/customer/samples/details/${id}` :
                                        requestsCuttingId ?
                                            `/customer/orders/${orderId}/${encodeURIComponent(customerOrderNumber)}/${year}/requests-cutting/${requestsCuttingId}/${encodeURIComponent(requestsCuttingNumber)}/details/${id}` :
                                            `/customer/orders/${orderId}/${encodeURIComponent(customerOrderNumber)}/${year}/requests-cutting/details/${id}`}>
                                    <Box sx={{
                                        color: (theme) => rowData.requiresImprovement ? theme.palette.error.main : "#006CCC"
                                    }}> {cell.getValue() === null ? '' : cell.getValue()}
                                    </Box>
                                </Link>}
                        </Tooltip>
                        <VisibilityIcon
                            aria-owns={popoverOpen ? 'mouse-over-popover' : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(event) => handleOpenSeeDetail(event.currentTarget, rowData)}
                            onMouseLeave={() => setSeeDetailData({position: null, data: null})}
                            sx={{
                                color: (theme) => theme.palette.text.light,
                                fontSize: "24px",
                                cursor: "pointer"
                            }}></VisibilityIcon>
                    </li>
                }
            },

                {
                    id: 'name',
                    header: 'Наименование',
                    accessorKey: samples ? "detailDto.name" : "name",
                    size: 300,
                    grow: true,
                    Cell:
                        ({cell, row}) => <Box sx={{
                            color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                        }}>{cell.getValue()}</Box>,
                },
                {
                    id: 'groupName',
                    header: 'Группа',
                    accessorKey: 'group.name',
                    size: 300,
                    grow: false,
                },
                {
                    id: 'length',
                    header: 'L',
                    accessorKey: samples ? "detailDto.length" : "length",
                    size: 10,
                    grow: false,
                    Cell:
                        ({cell, row}) => <Box sx={{
                            color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                        }}>{cell.getValue()}</Box>,
                }, {
                    id: 'width',
                    header: 'W',
                    accessorKey: samples ? "detailDto.width" : "width",
                    size: 10,
                    grow: false,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>,
                }, {
                    id: 'height',
                    header: 'H',
                    accessorKey: samples ? "detailDto.height" : "height",
                    size: 10,
                    grow: false,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>,
                },
                {
                    id: 'l1',
                    header: 'l1',
                    accessorKey: 'l1',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => {
                        return <Tooltip arrow placement="top" title={row.original.l1Name}>
                            <Box sx={{
                                color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                            }}>{cell.getValue()}</Box>
                        </Tooltip>
                    },
                },
                {
                    id: 'l2',
                    header: 'l2',
                    accessorKey: 'l2',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => {
                        return <Tooltip arrow placement="top" title={row.original.l2Name}>
                            <Box sx={{
                                color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                            }}>{cell.getValue()}</Box>
                        </Tooltip>
                    },
                },
                {
                    id: 'w1',
                    header: 'w1',
                    accessorKey: 'w1',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => {
                        return <Tooltip arrow placement="top" title={row.original.w1Name}>
                            <Box sx={{
                                color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                            }}>{cell.getValue()}</Box>
                        </Tooltip>
                    },
                },
                {
                    id: 'w2',
                    header: 'w2',
                    accessorKey: 'w2',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => {
                        return <Tooltip arrow placement="top" title={row.original.w2Name}>
                            <Box sx={{
                                color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                            }}>{cell.getValue()}</Box>
                        </Tooltip>
                    },
                },
                {
                    id: 'packagingMaterialName',
                    header: 'Упаковка',
                    accessorKey: 'packagingMaterialName',
                    size: 300,
                    grow: true,
                },

                {
                    id: 'quantity',
                    header: 'кол.',
                    accessorKey: samples ? "detailDto.quantity" : "quantity",
                    size: 10,
                    grow: false,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>,
                },
            ];

            if (!requestsCuttingId && !samples) {
                baseColumns.splice(10, 0, {
                    id: 'materialName',
                    header: 'Материал',
                    accessorKey: 'materialName',
                    size: 300,
                    grow: true,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>,
                });
            }
            if (!samples) {
                baseColumns.splice(2, 0, {
                    id: 'turn',
                    header: 'Поворот',
                    accessorKey: 'turn',
                    size: 10,
                    grow: false,
                    enableEditing: false,
                    filterVariant: 'multi-select',
                    filterSelectOptions: FilterUtil.statusList,
                    filterFn: (row, id, filterValue) => {
                        return FilterUtil.checkStatus(row.getValue(id), filterValue)
                    },
                    Cell: ({cell, row}) => <CellCheckboxWithUnable
                        id={row.id}
                        unable={unableTurn}
                        disabled={true}
                    >
                    </CellCheckboxWithUnable>,
                });
            }


            return baseColumns;

        }, [data, isColumnMaterial, isColumnOrder]);

        const menuItem = (() => {
            const actions = [];
            if (!samples || samples && (!system || admin)) {
                actions.push({type: "edit", text: "Редактировать", handler: handleUpdateDetail})
                actions.push({type: "delete", text: "Удалить", handler: handleDeleteDetail},)
                actions.push({type: "processing", text: "Обработка", handler: redirectProcessing},)
                if (materialId && !samples) {
                    actions.push({type: "addPackaging", text: "Добавить упаковку", handler: handleAddPackaging},)
                }
                if (!samples) {
                    actions.push({type: "removePackaging", text: "Удалить упаковку", handler: removePackaging})
                }

            } else {
                actions.push({type: "processing", text: "Обработка", handler: redirectProcessing})
            }
            return actions;
        })();

        const handleSelectAction = (action, packagingId) => {
            setLoading(true)
            if (action === "addPackaging") {
                PackagingControllerService.add(orderId, {
                    "detailIds": Object.keys(rowSelection),
                    "packagingId": {
                        "packagingId": packagingId
                    }
                }).then(() => {
                    setRowSelection([])
                    setChange((change) => !change)
                    handleModalAlert("Данные изменены", 'success')
                }).catch(function (error) {
                    handleModalAlert(error)
                }).finally(() => setLoading(false))
            } else {
                PackagingControllerService.remove(orderId, Object.keys(rowSelection)).then(() => {
                    setRowSelection([])
                    setChange((change) => !change)
                    handleModalAlert("Данные изменены", 'success')
                }).catch(function (error) {
                    handleModalAlert(error)
                }).finally(() => setLoading(false))
            }
            setOpen(false)
        }
        const modalActions = [
            {name: "Убрать упаковку", type: "removePackaging"},
            {name: "Добавить упаковку", type: "addPackaging"},
        ]

        return (<Box sx={{overflow: 'auto'}}>
            {!modal && <Box
                sx={{display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "16px"}}
            >
                {requestsCuttingId && <ButtonCreate
                    text={"Добавить по шаблону"}
                    width={230}
                    onClick={() => setModalSamplesOpen(true)}
                    disabled={isError}
                />
                }
                {
                    (samples && (!system || admin)) && <ButtonCreate
                        text={"Добавить из файла"}
                        width="auto"
                        height="auto"
                        sx={buttonCreateAutoSizeSx}
                        onClick={() => setModalImportOpen(true)}
                        disabled={isError}
                    />
                }
                {
                    (requestsCuttingId || (samples && (!system || admin))) &&
                    <ButtonCreate
                        text={"Добавить деталь"}
                        width={samples && !requestsCuttingId ? "auto" : 190}
                        height={samples && !requestsCuttingId ? "auto" : 38}
                        sx={samples && !requestsCuttingId ? buttonCreateAutoSizeSx : undefined}
                        onClick={handleAddDetail}
                        disabled={isError}
                    />
                }
            </Box>
            }
            <MaterialReactTable
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        "&:first-of-type": !modal && {
                            padding: 0,
                            width: "100%",
                            height: "36px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: (theme) => theme.palette.text.light,
                            "& .MuiButtonBase-root": {
                                borderRadius: "4px",
                                width: "24px",
                                height: "24px",
                                opacity: 1,
                                margin: 0,
                                padding: 0,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                }
                            }
                        },
                        "& li": {
                            listStyleType: "none",
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            }
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        onClick: () => modal && setSelectedSamples(row.original),
                        sx: () => ({
                            height: '36px',
                            cursor: modal && "pointer",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            '&:nth-of-type(even)': {
                                backgroundColor: modal && selectedSamples && row.original?.id === selectedSamples?.id ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    backgroundColor: modal && selectedSamples && row.original?.id === selectedSamples?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                },
                            },
                            backgroundColor: modal && selectedSamples && row.original?.id === selectedSamples?.id ? (theme) => theme.palette.primary.light : "white",
                            "&:hover": {
                                backgroundColor: modal && selectedSamples && row.original?.id === selectedSamples?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                        })
                    })
                }}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 10,
                        grow: false,
                    },
                    'mrt-row-select': {
                        size: 10,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                columns={columns}
                data={isError ? [] : data}
                rowHeight={13}
                columnSpacing={1}
                initialState={{
                    columnVisibility: {
                        id: false,
                        material: isColumnMaterial,
                        order: isColumnOrder,
                        packagingMaterialName: !samples,
                        groupName: samples && !modal,
                        quantity: !samples,
                        turn: !modal,
                        height: !modal,
                    },
                    density: "compact",
                    grouping: columnGrouping,
                    // expanded: expanded,
                    pagination: tableOptions,
                    sorting: [{id: 'position', desc: false}],
                }}
                enableGrouping={enableGrouping}
                onRowSelectionChange={setRowSelection}
                state={{rowSelection, showGlobalFilter: true, pagination: samples && tableOptions}}
                enableRowSelection={requestsCuttingId}
                getRowId={(originalRow) => originalRow.id}
                selectionPadding={1}
                selectionCss={{
                    backgroundColor: 'lightblue',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: 'blue',
                    borderRadius: '4px',
                }}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
                onPaginationChange={(updater) => {
                    samples && tableOptionsHandle(updater(tableOptions));
                }}
                onGlobalFilterChange={value => tableOptionsHandle({...tableOptions, searchData: value})}
                manualPagination={true}
                paginateExpandedRows={false}
                localization={MRT_Localization_RU}
                enableRowActions={!modal}
                enableToolbarInternalActions={false}
                enableColumnActions={false}
                enableStickyHeader={true}
                enableStickyFooter={true}
                muiTableContainerProps={{
                    sx: {
                        maxHeight: samples ? `calc(100vh - 405px)` : `calc(100vh - 650px)`,
                    }
                }}
                selectAllMode={'all'}
                muiToolbarAlertBannerProps={{
                    sx: {
                        backgroundColor: (theme) => theme.palette.primary.light,
                        "& .MuiStack-root": {
                            padding: 0,
                        },
                    }
                }}
                renderTopToolbar={({table}) => {
                    const backgroundBlue = table.getState().grouping.length > 0 || table.getSelectedRowModel().rows.length > 0
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => backgroundBlue ? theme.palette.primary.light : "transparent",
                        "& .MuiStack-root": {
                            padding: "1px",
                            flexDirection: "row-reverse",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "40px",
                        },
                    }}>
                        <MRT_ToolbarAlertBanner
                            table={{...table, options: {...table.options, rowCount: tableOptions.totalElements}}}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                renderBottomToolbar={({table}) => {
                    const tableProps = table.getState().grouping.length > 0
                        ? {
                            ...table,
                            options: {
                                ...table.options,
                                localization: {
                                    ...table.options.localization,
                                    rowsPerPage: `Всего строк: ${tableOptions.totalElements}. Сгруппированных элементов на странице:`
                                }
                            }
                        }
                        : table
                    return <MRT_BottomToolbar table={tableProps}/>
                }}
            />
            <ModalAddDetail
                open={createOrUpdateModalOpen}
                onClose={handleCloseCreateOrUpdate}
                title={isNew ? 'Создать деталь' : 'Редактировать деталь'}
                labelButtonSubmit={isNew ? 'Создать' : 'Обновить'}
                handleSubmit={isNew ? handleSubmitCreateDetail : handleSubmitUpdateDetail}
                initValue={currentEditRowData}
                initValueGroup={initValueGroup}
                uniqueNames={isNew ? uniqueNames : uniqueNames.filter(el => el !== currentEditRowData.position)}
                samples={samples}
                handleModalAlert={handleModalAlert}
                materialTreeData={materialTreeData}
                handleActiveItemsChange={handleActiveItemsChange}
                loading={loading}
            />
            {materialTreeData && (
                <ModalImport
                    open={modalImportOpen}
                    onClose={() => setModalImportOpen(false)}
                    handleModalAlert={handleModalAlert}
                    initValueGroup={initValueGroup}
                    materialTreeData={materialTreeData}
                    handleActiveItemsChange={handleActiveItemsChange}
                    setData={setData}
                />
            )}
            <ModalAddBySamples
                open={modalSamplesOpen}
                onClose={() => setModalSamplesOpen(false)}
                handleSubmit={handleSubmitSamples}
                loading={loading}
            />
            <ModalAddPackaging
                open={modalPackaging}
                onClose={handleCloseAddPackaging}
                handleSubmit={handleAddPackagingByDetailId}
                initValue={currentEditRowData}
                materialId={materialId}
                handleModalAlert={handleModalAlert}
                loading={loading}
            />
            <ModalAlert data={alertData} onClose={handleCloseAlert}/>
            {
                Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>
            }
            <ModalSelectAction
                open={open}
                reset={() => setOpen(false)}
                submit={handleSelectAction}
                modalActions={modalActions}
                materialId={materialId}
                handleModalAlert={handleModalAlert}
                loading={loading}
            />
            {
                seeDetailData.data && <ModalSeeDetail
                    open={popoverOpen} seeDetailData={seeDetailData}
                    handleClose={() => setSeeDetailData({position: null, data: null})}></ModalSeeDetail>
            }
        </Box>)
            ;
    }
;

export default CustomerDetailsTable;
